import { useEffect } from 'react';
import { ReadonlyURLSearchParams } from 'next/navigation';
import { ManufacturerOption } from '../types/ManufacturerOption';
import { getManufacturerFromParam } from './getManufacturerFromParam';

// hook for handling knob manufacturer preselection based on url in param
export function useManufacturerSelection(
  manufacturerOptions: ManufacturerOption[],
  searchParams: ReadonlyURLSearchParams,
  setSelectedManufacturer: (option: ManufacturerOption | undefined) => void,
  setHasDoorKnob: (hasKnob: boolean) => void,
) {
  useEffect(() => {
    if (manufacturerOptions && manufacturerOptions.length > 0) {
      const manufacturerInParam = getManufacturerFromParam(searchParams);
      const preselectManufacturer = manufacturerOptions.find(
        (manufacturer) => manufacturer.value === manufacturerInParam,
      );

      // If knob url param is present
      if (manufacturerInParam) {
        // If the manufacturer variant is valid and available
        if (preselectManufacturer) {
          setSelectedManufacturer(preselectManufacturer);
        } else {
          // knob url param is present but option is invalid - Select firt option as a default
          setSelectedManufacturer(manufacturerOptions[0]);
        }
        setHasDoorKnob(true);
      } else {
        // No knob url param - preselect firt option as a default, but doorknob stay false by default
        setSelectedManufacturer(manufacturerOptions[0]);
      }
    }
  }, [manufacturerOptions, searchParams, setHasDoorKnob, setSelectedManufacturer]);
}
